import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { Search, Filter, X } from "lucide-react";

const CATEGORIES = [
  { value: '', label: 'सभी श्रेणियां', labelEn: 'All Categories' },
  { value: 'AGRO BASED', label: 'कृषि आधारित', labelEn: 'Agro Based' },
  { value: 'SERVICE', label: 'सेवा उद्योग', labelEn: 'Service' },
  { value: 'POLYMER AND CHEMICAL', label: 'रासायनिक', labelEn: 'Chemical' },
  { value: 'MINERAL BASED', label: 'खनिज आधारित', labelEn: 'Mineral' },
  { value: 'FOREST BASED', label: 'वन आधारित', labelEn: 'Forest' },
  { value: 'RURAL ENGINEERING', label: 'ग्रामीण इंजीनियरिंग', labelEn: 'Rural Eng.' },
  { value: 'TEXTILE', label: 'वस्त्र उद्योग', labelEn: 'Textile' },
];

const formatCost = (value) => {
  if (value >= 100) return `${value / 100} करोड़`;
  return `${value} लाख`;
};

export const FilterSidebar = ({
  search,
  setSearch,
  category,
  setCategory,
  costRange,
  setCostRange,
  onReset,
  isMobile = false,
  onClose
}) => {
  return (
    <div className={`${isMobile ? 'p-4' : 'sticky top-20'}`}>
      {isMobile && (
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-rajdhani font-bold text-lg text-gray-800">फ़िल्टर</h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg text-gray-600">
            <X className="w-5 h-5" />
          </button>
        </div>
      )}
      
      <div className="space-y-6 bg-white p-5 rounded-xl border border-gray-200 shadow-sm">
        {/* Search */}
        <div>
          <Label className="text-gray-600 text-sm mb-2 block font-medium">खोजें</Label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <Input
              placeholder="प्रोजेक्ट का नाम..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="pl-10 border-gray-200 focus:border-orange-300 focus:ring-orange-200 bg-gray-50"
              data-testid="search-input"
            />
          </div>
        </div>

        {/* Category */}
        <div>
          <Label className="text-gray-600 text-sm mb-2 block font-medium">श्रेणी</Label>
          <div className="grid grid-cols-2 gap-2">
            {CATEGORIES.map((cat) => (
              <button
                key={cat.value}
                onClick={() => setCategory(cat.value)}
                className={`px-3 py-2 text-xs rounded-lg border transition-all ${
                  category === cat.value
                    ? 'bg-orange-50 border-orange-300 text-orange-600 font-medium'
                    : 'bg-gray-50 border-gray-200 text-gray-600 hover:border-gray-300 hover:bg-gray-100'
                }`}
                data-testid={`category-${cat.value || 'all'}`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>

        {/* Cost Range */}
        <div>
          <Label className="text-gray-600 text-sm mb-2 block font-medium">बजट सीमा (लाख में)</Label>
          <div className="px-2">
            <Slider
              value={costRange}
              onValueChange={setCostRange}
              min={0}
              max={100}
              step={5}
              className="my-4"
              data-testid="cost-slider"
            />
            <div className="flex justify-between text-xs text-gray-500">
              <span className="bg-orange-50 px-2 py-1 rounded text-orange-600">₹{formatCost(costRange[0])}</span>
              <span className="bg-orange-50 px-2 py-1 rounded text-orange-600">₹{formatCost(costRange[1])}</span>
            </div>
          </div>
        </div>

        {/* Reset */}
        <Button
          variant="outline"
          onClick={onReset}
          className="w-full border-gray-300 text-gray-600 hover:bg-gray-100 rounded-lg"
          data-testid="reset-filters-btn"
        >
          <Filter className="w-4 h-4 mr-2" />
          फ़िल्टर रीसेट करें
        </Button>
      </div>
    </div>
  );
};
